module.exports = __webpack_public_path__ + "static/media/ryebridge-logo-alt.45904416.svg";